import icon from "~/components/ui/icons/svg/bag-icon.svg";
import { cn } from "~/lib/ui";

export const BagIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("inline", className)}
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};
